import { render, staticRenderFns } from "./AddEditVacationDays.vue?vue&type=template&id=10454a72&scoped=true"
import script from "./AddEditVacationDays.vue?vue&type=script&lang=js"
export * from "./AddEditVacationDays.vue?vue&type=script&lang=js"
import style0 from "./AddEditVacationDays.vue?vue&type=style&index=0&id=10454a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10454a72",
  null
  
)

export default component.exports